import { addToken, client } from './client';

export const pumpService = {
  getYieldData
};

async function getYieldData(token, fieldid) {
  return client.get(`/pump/getYieldData?fieldid=${fieldid}`, addToken(token));
}
